import storage from '../../utils/storage'

const STORAGE_KEY = 'tr_v3_admins_real'

export default {
  state: {
    admins: []
  },
  mutations: {
    SET_ADMINS(state, list) {
      state.admins = list
      storage.set(STORAGE_KEY, list)
    },
    ADD_ADMIN(state, admin) {
      state.admins.push(admin)
      storage.set(STORAGE_KEY, state.admins)
    },
    UPDATE_ADMIN(state, admin) {
      const idx = state.admins.findIndex(a => a.admin_id === admin.admin_id)
      if (idx >= 0) {
        state.admins.splice(idx, 1, admin)
        storage.set(STORAGE_KEY, state.admins)
      }
    },
    DELETE_ADMIN(state, id) {
      state.admins = state.admins.filter(a => a.admin_id !== id)
      storage.set(STORAGE_KEY, state.admins)
    },
    TOGGLE_ADMIN_STATUS(state, id) {
      const admin = state.admins.find(a => a.admin_id === id)
      if (admin) {
        admin.status = admin.status === 1 ? 0 : 1
        storage.set(STORAGE_KEY, state.admins)
      }
    }
  },
  getters: {
    allAdmins: state => state.admins,
    activeAdmins: state => state.admins.filter(a => a.status === 1),
    adminByEmail: state => email => state.admins.find(a => a.email === email),
    adminById: state => id => state.admins.find(a => a.admin_id === id),
    superAdminCount: state => state.admins.filter(a => a.role === 'super_admin').length,
    normalAdmins: state => state.admins.filter(a => a.role === 'admin')
  }
}
